import React from 'react';

var ArrowUp = function ArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.414l6.293 6.293a1 1 0 0 0 1.414-1.414l-7-7a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 1.414 1.414L12 9.414z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowUp.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ArrowUp as icon };
export default iconHandler(ArrowUp);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ArrowUp.js
// module id = 583
// module chunks = 0